import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import {
    Box,
    Link,
    Typography,
} from "@mui/material"
import UploadComponent from "src/v2/components/upload/upload-component"

const CadastroLoteUpload = ({
    onSend,
}) => {
    const fileInputRef = useRef(null)
    const [uploadKey, setUploadKey] = useState(0)

    const handleEnviar = async (file) => {
        if (!file) return

        const sucesso = await onSend?.({
            arquivo: file,
        })

        if (sucesso) {
            if (fileInputRef.current) {
                fileInputRef.current.value = ""
            }

            setUploadKey((prev) => prev + 1)
        }
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                gap: 2,
                py: 2,
            }}
        >
            <Typography
                component="p"
                variant="textBody"
                sx={{
                    width: {
                        xs: "100%",
                        md: "75%",
                    },
                    maxWidth: "1000px",
                    color: "primary.contrastText",
                    fontSize: "1rem",
                    textAlign: "center",
                    m: 0,
                }}
            >
                Baixe o arquivo de{" "}
                <Link
                    href="/example/ExemploCadastroEmLote.xlsx"
                    color="inherit"
                    underline="always"
                    download
                    sx={{
                        fontWeight: 700,
                    }}
                >
                    Exemplo
                </Link>{" "}
                e faça o upload abaixo.
            </Typography>

            <Box
                sx={{
                    width: {
                        xs: "100%",
                        md: "75%",
                    },
                    maxWidth: "1000px",
                }}
            >
                <UploadComponent
                    key={uploadKey}
                    variant="guided"
                    compact
                    accept=".xlsx,.xls,.csv,.json"
                    fileInputRef={fileInputRef}
                    onSendFile={handleEnviar}
                    buttonLabel="SELECIONAR ARQUIVO"
                    helperText="ou selecione um arquivo do seu computador"
                    formatHint="Formatos suportados: .xlsx, .xls, .csv ou .json"
                />
            </Box>
        </Box>
    )
}

CadastroLoteUpload.propTypes = {
    onSend: PropTypes.func,
}

export default CadastroLoteUpload